var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "8px",
    height: "8px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(90, 106, 137)",
    d: "M5.303,3.988 L7.771,1.520 C8.043,1.248 8.043,0.806 7.771,0.534 L7.442,0.205 C7.169,-0.068 6.727,-0.068 6.455,0.205 L3.988,2.672 L1.521,0.204 C1.248,-0.068 0.806,-0.068 0.534,0.204 L0.204,0.533 C-0.068,0.806 -0.068,1.248 0.204,1.520 L2.672,3.988 L0.205,6.455 C-0.068,6.727 -0.068,7.169 0.205,7.441 L0.534,7.770 C0.806,8.043 1.248,8.043 1.521,7.770 L3.988,5.303 L6.455,7.770 C6.728,8.043 7.169,8.043 7.442,7.770 L7.771,7.441 C8.043,7.169 8.043,6.727 7.771,6.455 L5.303,3.988 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.0796559a03e3cb8c8705b30cab7a27a0.svg";
export { ForwardRef as ReactComponent };